import Header from "../components/Header";
import "./scss/product.scss";
import { rootReducer } from "../store/store";
import { useDispatch, useSelector } from "react-redux";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import Check from "../components/Check";
import { useHistory } from "react-router-dom";
import { useEffect, useState, useRef, RefObject } from "react";
import {
  AdditionRestChargeInfo,
  RestChargeInfo,
} from "../types/AdditionRestChargeTypes";
import InsuranceModal from "../components/InsuranceModal";
import {
  CarInsuranceChargeInfo,
  CarInsuranceInfo,
} from "../types/CarInsuranceChargeTypes";
import { useCommonUtil } from "../util/useCommonUtil";
import { product } from "../actions/authActions";
import { AlertType, alertType } from "../types/CommonType";
import AlertModal from "../components/AlertModal";
import React from "react";
import AddCarInsurance from "./addCarInsurance";
type AuthState = ReturnType<typeof rootReducer>;

interface RestChargeInsInfo {
  insuranceId: number;
  chargeRequester: number;
  insuranceName: string;
  reservationSubSerial: string;
  chargeType: string;
  chargeBase: number;
  chargeValue: number;
  chargeCustomer: number;
}
const Product: React.FC = () => {
  const { formatNumber, calculateAgeFromBirthdate, formatDate, sliceLicenseNumber, addHyphenToLicenseNumber, calculateYearsSinceIssued } = useCommonUtil();
  const [alertInfo, setAlertInfo] = useState<AlertType>(alertType);
  const resInfo = useSelector((state: AuthState) => state.store.resOneInfo);
  const [checkedItems, setCheckedItems] = useState<RestChargeInfo[]>([]); // 기타상품
  const [totalAddAmt, setTotalAddAmt] = useState<number>(0);
  const [checkedIns, setCheckedIns] = useState<CarInsuranceChargeInfo[]>([]); // 특약보험
  const [insuranceId, setInsuracneId] = useState<number>(Number(resInfo && resInfo?.data?.carInsuranceChargeInfo && resInfo?.data?.carInsuranceChargeInfo.filter(
    (e: CarInsuranceChargeInfo) =>
      e.carInsuranceInfo &&
      e.carInsuranceInfo.insuranceType === "4000"
  )[0]?.insuranceId | 0)
  );
  const [totalInsAmt, setTotalInsAmt] = useState<number>(0);

  const [detailShow, setDetailShow] = useState<boolean>(false);

  const driverInfo = useSelector((state: AuthState) => state.store.driver);
  console.log('driverInfo', driverInfo)
  resInfo?.data?.carInsuranceInfoArray && resInfo?.data?.carInsuranceInfoArray.forEach(element => {
    resInfo?.data?.carInsuranceChargeInfo && resInfo?.data?.carInsuranceChargeInfo.forEach(charge => {
      if (element.insuranceId === charge.insuranceId) {
        element.chargeRequester = charge.chargeRequester
        element.active = true
      } else {
        element.active = false
      }
    })
  });


  resInfo?.data?.additionChargeInfoArray && resInfo?.data?.additionChargeInfoArray.forEach(element => {
    resInfo?.data?.additionRestChargeInfoArray && resInfo?.data.additionRestChargeInfoArray.forEach(charge => {
      if (element.restChargeId === charge.restChargeId) {
        element.chargeRequester = charge.chargeRequester
        element.reservationId = String(charge.reservationId)
      }
    })
  })

  const history = useHistory();
  const dispatch = useDispatch();

  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const scrollContainerRef2 = useRef<HTMLDivElement>(null);
  console.log(resInfo);
  const scrollToTop = (scrollContainer: RefObject<HTMLDivElement>) => {
    const container = scrollContainer.current;
    if (container) {
      animateScroll(0, container.scrollTop, scrollContainer);
    }
  };

  const scrollToBottom = (scrollContainer: RefObject<HTMLDivElement>) => {
    const container = scrollContainer.current;

    if (container) {
      const maxScroll = container.scrollHeight - container.clientHeight;
      animateScroll(maxScroll, container.scrollTop, scrollContainer);
    }
  };

  const animateScroll = (
    target: number,
    current: number,
    scrollContainer: RefObject<HTMLDivElement>
  ) => {
    const step = (target - current) / 2; // 조절 가능한 부분: 더 큰 값을 사용하여 빠르게 이동
    let count = 0;

    const scrollAnimation = () => {
      count++;
      const nextScroll = current + step;
      const container = scrollContainer.current;

      if (container && count <= 10) {
        container.scrollTop = nextScroll;
        requestAnimationFrame(scrollAnimation);
      }
    };

    requestAnimationFrame(scrollAnimation);
  };

  const handleInsRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    item: CarInsuranceChargeInfo,
    chargeRequester: number
  ) => {
    const filteredItem: CarInsuranceChargeInfo = {
      insuranceId: item.insuranceId,
      chargeRequester: item.chargeRequester,
      insuranceName: item.insuranceName,
      reservationSubSerial: item.reservationSubSerial,
      chargeBase: item.chargeBase,
      chargeValue: item.chargeValue,
      chargeCustomer: item.chargeCustomer,
      reservationId: item.reservationId,
      companyId: item.companyId,
      carInsuranceInfo: item.carInsuranceInfo,
    };

    if (event.target.checked) {
      // 라디오 버튼이 선택된 경우
      setInsuracneId(item.insuranceId);
      setCheckedIns([filteredItem]);
      setTotalInsAmt(chargeRequester);
    }
  };

  const handleAddCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    item: AdditionRestChargeInfo,
    chargeRequester: number
  ) => {
    const restChargeId = item.restChargeId;
    console.log(item)
    const filteredItem: AdditionRestChargeInfo = {
      restChargeId: restChargeId,
      chargeRequester: chargeRequester,
      productName: item.productName,
      productCategory: item.productCategory,
      reservationId: item.reservationId,
      companyId: item.companyId,
      chargeBase: item.chargeBase,
      chargeVol: item.chargeVol,
      chargeValue: item.chargeValue,
      chargeCustomer: item.chargeCustomer,
      reservationSubSerial: item.reservationSubSerial,
      restChargeInfo: item.restChargeInfo,
    };

    if (event.target.checked) {
      // 체크박스가 선택된 경우
      setCheckedItems((prevCheckedItems) => [
        ...prevCheckedItems,
        filteredItem,
      ]);

      setTotalAddAmt((prevTotalAmt) => prevTotalAmt + chargeRequester);
    } else {
      // 체크박스가 선택 해제된 경우
      setCheckedItems((prevCheckedItems: any) =>
        prevCheckedItems.filter(
          (checkedItem: any) => checkedItem.restChargeId !== restChargeId
        )
      );
      setTotalAddAmt((prevTotalAmt) => prevTotalAmt - chargeRequester);
    }
  };

  const noSelectInsItem = () => {

    const resetCheckedIns = () => {
      setCheckedIns([]);
    };
    resetCheckedIns()
    setTotalInsAmt((prev) => {
      return prev - checkedIns[0].chargeRequester;
    })

    setInsuracneId(0)
  }

  const nextStep = () => {
    let ageErrorMsg = ""
    let yearErrorMsg = ""
    console.log(checkedIns)
    console.log('checkedItems', checkedItems)
    if (checkedIns && checkedIns.length > 0) {
      checkedIns.map(ins => {
        driverInfo && driverInfo.data && driverInfo.data.map(driver => {
          if (Number(calculateAgeFromBirthdate(formatDate(driver.birthday || ""))) < Number(ins.carInsuranceInfo.minAge)) {
            ageErrorMsg += `${ins.insuranceName} 보험은 ${ins.carInsuranceInfo.minAge}세부터 이용 가능합니다.(${driver.driverName}) <br/>`
          }
          const licenseNum = sliceLicenseNumber(addHyphenToLicenseNumber(driver.licenseNum || ""))
          const licenseYear = calculateYearsSinceIssued(Number(licenseNum)) < Number(ins.carInsuranceInfo.minCareer)
          if (licenseYear) {
            yearErrorMsg += `${ins.insuranceName} 보험은 운전경력 ${ins.carInsuranceInfo.minCareer}년 이상부터 <br/> 이용 가능합니다.(${driver.driverName}) <br/>`
          }
        })
      })
    }

    if (ageErrorMsg.length > 0) {
      setAlertInfo({
        title: '상품 확인',
        content: `${ageErrorMsg}`,
        show: true
      })
      return false;
    }
    if (yearErrorMsg.length > 0) {
      setAlertInfo({
        title: '상품 확인',
        content: `${yearErrorMsg}`,
        show: true
      })
      return false;
    }

    const req = {
      companyId: resInfo?.data?.companyId,
      reservationId: resInfo?.data.reservationId,
      modelId: resInfo?.data.modelId,
      modelName: resInfo?.data.modelName,
      addProductArr: checkedItems,
      addInsuranceArr: checkedIns,
    };

    console.log('req', req)

    dispatch(product(req));

    const etcProduct = resInfo?.data?.additionChargeInfoArray.find(etc => etc.restChargeInfo.guestViewStatus === "Y");

    if (!etcProduct) history.push("/resFinal");
    else history.push("/addEtc");

    if(resInfo?.data?.additionRestChargeInfoArray.length) history.push("/addEtc");

    // history.push("/addEtc");
  };

  const addLineBreaks = (text: string) => {
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  const adjustFontSize = (text: string, maxHeight: number) => {
    const baseFontSize = 35; // 기본 폰트 크기
    const maxCharsPerLine = 25; // 한 줄당 최대 글자 수
    const fontSizeStep = 1; // 한 글자당 폰트 크기가 줄어드는 양

    // 문자열의 길이에 따라 폰트 크기 조절
    const fontSize = baseFontSize - Math.floor(text.length / maxCharsPerLine) * fontSizeStep;


    return `${fontSize}px`; // 폰트 크기 반환

  };
  const handleTouchMove = (e: any) => {
    // 특정 div 영역 내에서는 터치 이벤트의 기본 동작을 막지 않음
    e.stopPropagation(); // 이벤트 전파 중단
  };


  useEffect(() => {
    setCheckedItems([])
    setCheckedIns([])
    setTotalAddAmt(0)

    if (resInfo?.data?.carInsuranceChargeInfo) {

      setCheckedIns((prevCheckedIns: CarInsuranceChargeInfo[]) => {
        const filteredArray = resInfo?.data?.carInsuranceChargeInfo.filter(
          (e: CarInsuranceChargeInfo) =>
            e.carInsuranceInfo && e.carInsuranceInfo.insuranceType === '4000'
        );

        return (filteredArray?.map((e: CarInsuranceChargeInfo) => ({
          insuranceId: e.insuranceId || 0,
          chargeRequester: e.chargeRequester,
          insuranceName: e.insuranceName,
          reservationSubSerial: e.reservationSubSerial,
          chargeType: e.chargeType,
          chargeBase: e.chargeBase,
          chargeValue: e.chargeValue,
          chargeCustomer: e.chargeCustomer,
          reservationId: e.reservationId,
          companyId: e.companyId,
          carInsuranceInfo: e.carInsuranceInfo,
          memo: e.memo, 
          regType: e.regType,
        })) as CarInsuranceChargeInfo[]) || [];
      });

      setTotalInsAmt((prevTotalInsAmt) => {
        const filteredArray = resInfo?.data?.carInsuranceChargeInfo?.filter(
          (e: CarInsuranceChargeInfo) =>
            e.carInsuranceInfo?.insuranceType === "4000" && e.carInsuranceInfo.insuranceId === insuranceId
        );
        return (
          (filteredArray.length > 0 && filteredArray?.map((e: CarInsuranceChargeInfo) => e.chargeRequester || 0)
            .reduce((total, chargeRequester) => total + chargeRequester)) || 0
        );
      });
    }

    const productWrap = document.getElementById('add-ins-product-wrap');
    if (productWrap) {
      productWrap.addEventListener('touchmove', handleTouchMove, { passive: false });
      return () => {
        productWrap.removeEventListener('touchmove', handleTouchMove);
      };
    }
  }, [resInfo]);

  return (
    <>
      <Header></Header>
      {alertInfo.show && (
        <AlertModal
          onClose={() => {
            setAlertInfo(prev => ({ ...prev, show: false }))
          }}
          title={alertInfo.title}
          content={alertInfo.content}
        ></AlertModal>
      )}
      <div className="product-wrap">
        <div className="product-title-wrap">가입된 상품 </div>

        <div className="product-ins-wrap">
          <div className="ins-title">
            <span className="name">
              {" "}
              {resInfo?.data?.carInsuranceChargeInfo && resInfo?.data?.carInsuranceChargeInfo.length > 0 && resInfo?.data?.carInsuranceChargeInfo[0].insuranceName || '보험 없음'}
            </span>
            <div
              className="insurance-detail"
              onClick={() => resInfo?.data?.carInsuranceChargeInfo && resInfo?.data?.carInsuranceChargeInfo.length > 0 && setDetailShow(true)}
            >
              <span className="detail">상세보기</span>
              <img src="/img/icon-right.svg"></img>
            </div>
          </div>

          <div className="ins-dec">
            {resInfo?.data?.carInsuranceChargeInfo && resInfo?.data?.carInsuranceChargeInfo.length > 0 && (
              <span>
                {
                  resInfo?.data?.carInsuranceChargeInfo[0].carInsuranceInfo.insuranceTypeString}{" "}
                / 만 {resInfo?.data?.carInsuranceChargeInfo[0].carInsuranceInfo.minAge}세
                이상 / 운전경력{" "}
                {resInfo?.data?.carInsuranceChargeInfo[0].carInsuranceInfo.minCareer}년
                이상 / 보상한도{" "}
                {resInfo?.data?.carInsuranceChargeInfo[0].carInsuranceInfo.limitPrice}
                만원 / 단독보장{" "}
                {
                  resInfo?.data?.carInsuranceChargeInfo[0].carInsuranceInfo.soloAccidentInclusionString}
              </span>
              )
            }
          </div>
        </div>

        {resInfo?.data?.carInsuranceChargeInfo && resInfo?.data?.carInsuranceChargeInfo.length > 0 ? (
          <div className="ins-etc-wrap " id="content"
              style={{ fontSize: resInfo?.data?.carInsuranceChargeInfo && resInfo?.data?.carInsuranceChargeInfo.length > 0 ? adjustFontSize(resInfo?.data?.carInsuranceChargeInfo[0].carInsuranceInfo.content || '', 400) : '' }}
          >
            <span> {resInfo?.data?.carInsuranceChargeInfo && resInfo?.data?.carInsuranceChargeInfo.length > 0 ? addLineBreaks(resInfo?.data?.carInsuranceChargeInfo[0].carInsuranceInfo.content || '') : ''}</span>
                {/* // 보험 중 단독보장 불포함인 경우 단독사고(뺑소니포함) 및 과실 100%의
              // 사고는 보험 적용이 되지 않습니다. */}
          </div>
        ) : (
          <div className="ins-etc-wrap" id="content"
              style={{ fontSize: adjustFontSize('자차미가입시 차량 사고비용 전액과 휴차보상료가 발생합니다.', 300)}}
          >
            현재 자차 보험 가입이 되어 있지 않습니다.<br/>
            자차미가입시 <span style={{color:"red", fontWeight:"600"}}> 차량 사고비용 전액과 휴차보상료가 발생합니다.</span>
          </div>
        )}
        
        {resInfo?.data?.carInsuranceChargeInfo && resInfo?.data?.carInsuranceChargeInfo.length > 0 ? (
        <>
          <div className="product-title-wrap">특약 상품 추가하기</div>
          <div className="add-ins-wrap">
            <div className="title">
              <span>자차특약</span>
              <div className="icon-wrap">
                <SvgIcon
                  component={ErrorOutlineOutlinedIcon}
                  style={{ marginRight: "5px" }}
                ></SvgIcon>
                <span>중복 선택 불가</span>
              </div>
            </div>
            <div className="add-ins-product-wrap" ref={scrollContainerRef2} id="add-ins-product-wrap">
              {resInfo?.data?.carInsuranceInfoArray?.length === 0 ? (
                <p style={{ fontSize: "1.5em" }}>등록된 특약 상품이 없습니다.</p>
              ) : (
                <>
                  {resInfo?.data?.carInsuranceInfoArray
                    ?.filter(
                      (item: CarInsuranceChargeInfo) => 
                        item.carInsuranceInfo.insuranceType === '4000' && 
                        resInfo?.data?.carInsuranceChargeInfo[0] && 
                        resInfo?.data?.carInsuranceChargeInfo[0].carInsuranceInfo.insuranceType !== item.carInsuranceInfo.relatedInsuranceType
                    )
                    .map((item: CarInsuranceChargeInfo, idx: number) => (
                      <label key={idx}>
                        <div className="product-list" style={{ alignItems: "center" }}>
                          <div style={{ width: "45px" }}>
                            <div className="nm-radio">
                              <input
                                type="radio"
                                value={insuranceId}
                                checked={checkedIns.some((e) => insuranceId === item.insuranceId)}
                                onChange={(event) =>
                                  handleInsRadioChange(event, item, item.chargeRequester)
                                }
                              ></input>
                              <span className="radio"></span>
                            </div>
                          </div>
                          <div className="product-name">
                            <span style={{ marginBottom: "7px" }}>
                              {item.insuranceName}
                            </span>
                            <span className="etc">
                              {addLineBreaks(item.carInsuranceInfo?.contentBurden || '')}
                            </span>
                          </div>
                          <div className="product-price-wrap">
                            <span>{formatNumber(item.chargeRequester || 0)}원</span>
                          </div>
                        </div>
                      </label>
                    ))
                  }
                  <label>
                    <div className="product-list" style={{ alignItems: "center" }}>
                      <div style={{ width: "45px" }}>
                        <div className="nm-radio">
                          <input
                            type="radio"
                            value={insuranceId}
                            checked={insuranceId === 0}
                            onChange={(event) =>
                              noSelectInsItem()
                            }
                          ></input>
                          <span className="radio"></span>
                        </div>
                      </div>
                      <div className="product-name">
                        <span style={{ marginBottom: "7px" }}>
                          선택 없음
                        </span>
                        <span className="etc">
                        </span>
                      </div>
                      <div className="product-price-wrap">
                        <span>{formatNumber(0)}원</span>
                      </div>
                    </div>
                  </label>
                </>
              )}
            </div>
          </div>
        </>
        ) : (
          <AddCarInsurance handleInsRadioChange={handleInsRadioChange} noSelectInsItem={noSelectInsItem}/>
        )}        

        <div
          className="arrow-wrap"
          style={{
            background: "white",
            position: "relative",
            height: "auto",
            width: "calc(100% + 0px)",
          }}
        >
          <SvgIcon
            component={KeyboardArrowUpOutlinedIcon}
            style={{
              fontSize: "5em",
              marginRight: "30px",
              color: "#e4e7ec",
            }}
            onClick={() => {
              scrollToTop(scrollContainerRef2);
            }}
          ></SvgIcon>
          <SvgIcon
            component={KeyboardArrowDownOutlinedIcon}
            style={{ fontSize: "5em", color: "#3E83F1" }}
            onClick={() => {
              scrollToBottom(scrollContainerRef2);
            }}
          ></SvgIcon>
        </div>

        <div className="total-price-wrap">
          <div style={{ width: "50%", marginRight: "40px" }}>
            <div className="info-wrap">
              <span className="total-count-label">총 수량</span>
              <span className="total-count">
                {checkedItems.length + (checkedIns.length)}개
              </span>
            </div>

            <div className="info-wrap">
              <span className="total-count-label">추가 금액</span>
              <span className="total-count">
                {formatNumber(totalAddAmt + totalInsAmt)}원{" "}
              </span>
            </div>
          </div>
          <div className="btn-wrap" style={{ width: "50%" }}>
            <button onClick={nextStep}>다음 단계로</button>
          </div>
        </div>

        {detailShow && (
          <InsuranceModal
            detail={resInfo?.data?.carInsuranceChargeInfo && resInfo?.data?.carInsuranceChargeInfo[0]}
            onClose={() => {
              setDetailShow(false);
            }}
          ></InsuranceModal>
        )}
      </div>
    </>
  );
};

export default Product;
